import client from './client';

export interface PlatformStats {
  activeUsers: number;
  eventsCreated: number;
  photosServed: number;
}

export const statsApi = {
  getPlatformStats: () =>
    client.get<PlatformStats>('/stats/platform').then((r) => r.data),
};
